import axios from "axios";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { toast } from "react-toastify";

class StudyGroupSuperhostWebinarFeedback extends Component {
  constructor(props) {
    super(props);
    this.webinarId = Number(props.params.webinarId);
    this.feedbackId = Number(props.params.feedbackId);
    this.state = {
      feedback: {},
      questions: [],
      showPopup: false,
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    axios.get(`/api/v1/feedback_forms/${this.feedbackId}`).then((res) => {
      this.setState((prev) => ({
        ...prev,
        questions: res.data.feedback_form.questions.map((item) => {
          switch (item.question_type) {
            case "rate":
              return {
                min: item.options[0],
                max: item.options[1],
                answers: ["1", "2", "3", "4", "5"],
                question: item.body,
              };
            case "topic":
              return {
                topic: item.body,
              };
            case "variant":
              return {
                answers: item.options,
                question: item.body,
              };
            case "text":
              return {
                text: item.body,
              };
            default:
              return {};
          }
        }),
      }));
    });
  };

  onChange = (item, event) => {
    this.setState({
      feedback: {
        ...this.state.feedback,
        [item.text || item.question]: event.target.value,
      },
    });
  };

  onTextAreaChange = (event) => {
    this.onItemChange(
      {
        label: "additionalComment",
        question:
          "Please provide any additional comments in relation to the organisation of the activity.",
      },
      event
    );
  };

  onSubmit = () => {
    if (Object.keys(this.state.feedback).length < 1) {
      toast.warning("At least one field is required to be filled");
      return;
    }

    const evaluation_forms = Object.keys(this.state.feedback).map((key) => ({
      question: key,
      answer: this.state.feedback[key],
    }));

    axios
      .post("api/v1/evaluation_forms", {
        webinar_id: this.webinarId,
        evaluation_forms,
      })
      .then(() => {
        this.setState({ ...this.state, showPopup: true });
      });
  };

  render() {
    return (
      <Feedback
        feedback={this.state.feedback}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        showPopup={this.state.showPopup}
        webinarId={this.webinarId}
        questions={this.state.questions}
        groupId={this.props.params.id}
      />
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostWebinarFeedback);

const Feedback = ({
  feedback,
  questions,
  onChange,
  onSubmit,
  showPopup,
  webinarId,
  groupId,
}) => {
  return (
    <main className="site--width">
      <div className="feedback_form">
        <div className="feedback_form_container_title">
          <div className="feedback_form_title">Evaluation Form</div>
          {/*<div className="feedback_form_underline"></div>*/}
        </div>
        {questions.map((item) => (
          <div className="feedback_answer_block">
            {item.topic && (
              <div className="feedback_form_description">{item.topic}</div>
            )}
            {item.question && (
              <div className="feedback_question">{item.question}</div>
            )}
            {item.answers && (
              <div className="form-box-feedback">
                <FormControl>
                  <RadioGroup
                    name={item.question}
                    value={feedback[item.question]}
                    onChange={(e) => {
                      onChange(item, e);
                    }}
                    row
                  >
                    {item.min && <p className="low_grading"> {item.min} </p>}
                    {item.answers.map((answer) => (
                      <FormControlLabel
                        value={answer}
                        control={<Radio color="primary" />}
                        label={answer}
                      />
                    ))}
                    {item.max && <p className="low_grading"> {item.max} </p>}
                  </RadioGroup>
                </FormControl>
              </div>
            )}
            {item.text && (
              <div className="texteria_feedback">
                <textarea
                  placeholder={item.text}
                  name={item.text}
                  onChange={(e) => onChange(item, e)}
                ></textarea>
              </div>
            )}
          </div>
        ))}

        <div className="button_submit">
          <button className="submit_feedback" onClick={onSubmit}>
            Submit Feedback
          </button>
        </div>
      </div>
      {showPopup && (
        <div>
          <div className="feedback-popup-container"></div>
          <div className="feedback-popup">
            <div className="feedback-popup-description">
              Thank you for your feedback
            </div>
            <div className="feedback-popup-title">
              Your feedback helps us to improve our content offering on MedCafe
            </div>
            <div className="feedback-popup-button">
              <Link
                className="back-to-webinars"
                activeClassName={"active"}
                to={`/groups/${groupId}/webinars/${webinarId}`}
              >
                Close
              </Link>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostWebinarFeedback.jsx